<template>
  <div class="carousel_wrap">
    <el-carousel :height="height" arrow="never" :indicator-position="imgList.length > 1 ? '' : 'none'">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <img :src="item.image" class="img_item" @click="gotoPage(item)" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import CifuAPI from "@/utils/api";
import { mapState } from "vuex";
export default {
  props: {
    type: {
      type: String,
      default: "banner",
    },
  },
  computed: {
    ...mapState(["platform"]),
  },
  data() {
    return {
      height: "900px",
      imgList: [],
    };
  },
  methods: {
    async getBannerList() {
      const res = await CifuAPI.getBannerList({ type: this.type });
      console.log(this.type)
      if (res.code == 1) {
        this.imgList = res.data;
      }
    },
    adjustHeight() {
      // 根据设备类型和页面类型设置不同高度
      const screenWidth = window.innerWidth;
      
      if (this.platform == "web") {
        if (this.type == "banner") {
          const bili = 1920 / 900;
          this.height = screenWidth / bili + "px";
        } else {
          const bili = 1920 / 460;
          this.height = screenWidth / bili + "px";
        }
      } else {
        if (this.type == "banner") {
          const bili = 375 / 234;
          this.height = screenWidth / bili + "px";
        } else {
          const bili = 375 / 125;
          this.height = screenWidth / bili + "px";
        }
      }
    },
    gotoPage(item) {
      if (item.url.length > 0) {
        this.$router.push(item.url);
      }
    },
  },
  created() {
    this.getBannerList();
  },
  mounted() {
    this.adjustHeight();
    // 监听窗口变化
    window.addEventListener("resize", this.adjustHeight);
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener("resize", this.adjustHeight);
  },
};
</script>

<style lang="scss" scoped>
.carousel_wrap {
  width: 100%;
  min-width: 1400px; // 设置合理的固定宽度，类似韩红基金会
  position: relative;
  z-index: 1; // 设置较低的z-index，确保不会覆盖导航栏
  
  // 处理浏览器放大后的情况
  @media screen and (min-width: 1401px) {
    min-width: auto; // 1200px以上恢复完全响应式
  }
  
  // 响应式高度调整
  @media screen and (max-width: 1400px) {
    min-width: 1400px; // 1200px以下固定宽度
  }
  
  // 只在真正的移动设备上应用移动端样式
  // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
  //   min-width: auto;
  // }
  
  // 确保轮播图正常显示
  ::v-deep .el-carousel {
    width: 100%;
    height: 100%;
    
    .el-carousel__container {
      width: 100%;
      height: 100%;
    }
    
    .el-carousel__item {
      width: 100%;
      height: 100%;
      
      .img_item {
        width: 100%;
        height: 100%;
        object-fit: cover;
        cursor: pointer;
      }
    }
    
    .el-carousel__indicators {
      bottom: 20px;
      z-index: 2;
    }
  }
}

// 确保图片正确显示
.img_item {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
  
  // 慈福轮播图图片优化 - 防止压缩和变形
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  image-rendering: pixelated;
  
  // 确保图片清晰度
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  
  // 防止图片被压缩
  backface-visibility: hidden;
  transform: translateZ(0);
  
  // 平滑过渡效果
  transition: all 0.3s ease;
  
}

// 轮播图容器优化
::v-deep .el-carousel {
  .el-carousel__item {
    .img_item {
      // 确保图片在轮播图中正确显示
      object-position: center;
      object-fit: cover;
      
      // 防止图片变形
      min-width: 100%;
      min-height: 100%;
    }
  }
}
</style>
